import { modelState } from '@/utils/modelState';
import { NumericConditionComponent } from './NumericConditionComponent';
import { QueryBuilder } from './QueryBuilder';
import { v4 as uuidv4 } from 'uuid';

export namespace DaysUntilArrivalCondition {

    export const registryEntry: QueryBuilder.ConditionRegistryEntry = {
        key: "DaysUntilArrival",
        name: "Days Until Arrival",
        isCondition: isDaysUntilArrivalCondition,
        create: createDaysUntilArrivalCondition,
        hydrate: hydrateDaysUntilArrivalCondition,
        serialize: serializeDaysUntilArrivalCondition,
        deserialize: deserializeDaysUntilArrivalCondition,
        renderComponent: renderComponent
    };

    export const DaysUntilArrivalCondition = Symbol("DaysUntilArrivalCondition");
    export interface DaysUntilArrivalCondition extends QueryBuilder.ConditionNodeChild {
        [DaysUntilArrivalCondition]: boolean;
        operator: modelState<string>;
        value: modelState<number>;
    }

    export function isDaysUntilArrivalCondition(condition?: QueryBuilder.ConditionNodeChild): condition is DaysUntilArrivalCondition {
        if (!condition) {
            return false;
        }

        return (condition as DaysUntilArrivalCondition)[DaysUntilArrivalCondition] === true;
    }

    export function createDaysUntilArrivalCondition(skipHydration: boolean = false): DaysUntilArrivalCondition {

        const condition: DaysUntilArrivalCondition = {
            [QueryBuilder.Node]: true,
            [QueryBuilder.ConditionNodeChild]: true,
            [DaysUntilArrivalCondition]: true,
            id: uuidv4(),
            version: modelState(0),
            operator: modelState("gt"),
            value: modelState(0),
            dispose: () => { }
        };

        if (!skipHydration) {
            hydrateDaysUntilArrivalCondition(condition);
        }

        return condition;
    }

    export function hydrateDaysUntilArrivalCondition(condition: DaysUntilArrivalCondition, recursive: boolean = false) {
        const unsubscribeList = [
            condition.operator.subscribe(() => {
                condition.version.setValue(condition.version.value + 1);
            }),
            condition.value.subscribe(() => {
                condition.version.setValue(condition.version.value + 1);
            })
        ];

        const oldDispose = condition.dispose;

        condition.dispose = () => {
            unsubscribeList.forEach(u => u());

            oldDispose();
        };
    }

    function serializeDaysUntilArrivalCondition(condition: DaysUntilArrivalCondition): QueryBuilder.ConditionChildNodeDtoWrapper {
        const conditionDto: DaysUntilArrivalConditionDto = {
            NodeId: condition.id,
            Operator: condition.operator.value,
            Value: condition.value.value
        };

        return {
            Type: "DaysUntilArrival",
            Value: conditionDto
        };
    }

    interface DaysUntilArrivalConditionDto extends QueryBuilder.NodeDto {
        Operator: string;
        Value: number;
    }

    function deserializeDaysUntilArrivalCondition(conditionDto: DaysUntilArrivalConditionDto): DaysUntilArrivalCondition {
        const condition = createDaysUntilArrivalCondition(true);

        condition.operator.setValue(conditionDto.Operator);
        condition.operator.commit();

        condition.value.setValue(conditionDto.Value);
        condition.value.commit();

        return condition;
    }

    function renderComponent(condition: DaysUntilArrivalCondition) {
        return (
            <div>
                <NumericConditionComponent operator={condition.operator} value={condition.value} />
            </div>
        );
    }
}